//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HiHeader from "../../components/header/Index.vue";
import HiProgress from "../../components/cancel_plan/Progress";
import { mapGetters } from "vuex";
import { cancel, unsubscription } from "../../services/payment";
import {
  CURRENT_USER_INFO_SIMPLE,
  CURRENT_USER_PLAN_LIST_SIMPLE,
} from "../../store/mutation-types";
import { showErrorMsg } from "../../utils/error";
export default {
  name: "CancelDetailPage",
  components: { HiHeader, HiProgress },
  data() {
    return {
      banner: [
        { text: "Feedback", active: true },
        { text: "Detail", active: true },
        { text: "Offer", active: true },
      ],
    };
  },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
      planList: CURRENT_USER_PLAN_LIST_SIMPLE,
    }),
    /**
     * 年付优惠前价格
     */
    savePrice() {
      const price = this.currentPlan.currentPlanCycle.totalPriceNum;
      return parseFloat(price.toPrecision(12));
    },
    currentPlanCycle() {
      const currentPlan = this.planList.find((p) => p.active);
      const currentCycle = currentPlan.billingCycles.find(
        (b) => b.id === this.user.plan.id
      );
      return currentCycle;
    },
    // 计算当前订阅的价格
    currentPrice() {
      return this.user.plan.cancelInfo.regularPrice;
    },
  },
  methods: {
    async cancelClick() {
      try {
        this.$loading.show();
        await cancel({ feedback: this.$route.query.feedback });
        this.$router.push({
          name: "PaymentHistoryPage",
          query: { back: "plan" },
        });
        this.$toast.show({ message: this.$t("common.success") });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    },
    async acceptClick() {
      try {
        this.$loading.show();
        await unsubscription({ feedback: this.$route.query.feedback });
        this.$router.push({ name: "MyPlanPage" });
        this.$alert.show({
          cancelText: "", // 不知道什么鬼。。总是被自动设置成cancel。。
          title: "Congrats",
          text: `Your plan remains active. Your next month is ${this.user.plan.cancelInfo.price}`,
          yesText: this.$t("common.ok"),
        });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        this.$loading.hide();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/cancel_plan/Offer.vue